import axios from "../http";

let module = "/dingtalk/class/";

function getSelectList() {
    return axios.get(module+"unimport", {});
}

function importClassAndStu(data) {
    return axios.post(module+"import/"+data);
}

export default {
    getSelectList,importClassAndStu,
}
